//
//
//
//
//
//

export default {
  name: 'product-card-info-item-tempo',
  props: {
    element: Object,
  },
  computed: {
    details() {
      return _.get(this.element, 'mediaTypeDetails', _.get(this.element, 'media_type_details'));
    },
    bpm() {
      return _.get(this.details, 'bpm', null);
    },
  },
};
